import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import AboutPage from './pages/AboutPage';
import ConcertVenuesPage from './pages/ConcertVenuesPage';
import FeaturesPage from './pages/FeaturesPage';
import HomePage from './pages/HomePage';
import HowItWorksPage from './pages/HowItWorksPage';
import RequestDemoPage from './pages/RequestDemoPage';
import SolutionsPage from './pages/SolutionsPage';
import TechnologyPage from './pages/TechnologyPage';
import { routes } from './config/links';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path={routes.home} element={<HomePage />} />
          <Route path={routes.features} element={<FeaturesPage />} />
          <Route path={routes.howItWorks} element={<HowItWorksPage />} />
          <Route path={routes.technology} element={<TechnologyPage />} />
          <Route path={routes.solutions} element={<SolutionsPage />} />
          <Route path={routes.solutionsConcertVenues} element={<ConcertVenuesPage />} />
          <Route path={routes.about} element={<AboutPage />} />
          <Route path={routes.requestDemo} element={<RequestDemoPage />} />
          <Route path="*" element={<Navigate to={routes.home} replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
